<template>
  <!-- <el-row
    class="log-list extension-page"
    :style="{ marginRight: `${marginRight}px`, marginLeft: `${marginLeft}px` }"
  > -->
  <el-button
    type="primary"
    style="color: #fff"
    class="el-button-minor log-btn"
    @click="showLog = true"
  >
    操作日志
  </el-button>
  <v-popup v-model:visible="showLog" :width="90">
    <!--操作日志列表-->
    <v-type-list title="操作日志" @query="search" @reset="reset">
      <template #title-right-content>
        <el-button @click="showLog = false">取消</el-button>
      </template>
      <template #search-condition-left>
        <el-col v-if="loginUserType === 0" :span="3">
          <v-select
            v-model:list="searchParams.merchantId"
            message="全部企业"
            url="/shopping-backend/api/merchant/list"
            value="id"
            name="company_name"
          />
        </el-col>
        <el-col :span="7">
          <el-date-picker
            v-model="time"
            size="medium"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="YYYY-MM-DD HH:mm:ss"
            :default-time="[
              new Date(0, 0, 0, 0, 0, 0),
              new Date(0, 0, 0, 23, 59, 59),
            ]"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="searchParams.eventName"
            placeholder="请输入操作事件"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="searchParams.title"
            placeholder="请输入操作对象名称"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="3">
          <el-input
            v-model="searchParams.operName"
            placeholder="请输入操作人"
            clearable
          ></el-input>
        </el-col>
      </template>

      <template #table>
        <!--表格-->
        <v-table
          ref="table"
          class="log-list-popup"
          :url="
            linkNum
              ? `/shopping-backend/api/operateLog/page/${linkNum}`
              : '/shopping-backend/api/operateLog/list'
          "
          method="post"
          :table-fields="logListFields"
          :condition="searchParams"
        >
        </v-table>
      </template>
    </v-type-list>
  </v-popup>
  <!-- </el-row> -->
</template>

<script lang="ts" setup>
import {
  ref,
  reactive,
  watch,
  computed,
  getCurrentInstance,
  onMounted,
} from "vue";
import { logListFields } from "@/data/headerData";

const app = getCurrentInstance()?.proxy;
const table = ref();

export interface Props {
  moduleName: string;
  marginRight: number | string;
  marginLeft: number | string;
  linkNum: number | string; //操作日志接口
}
const props = withDefaults(defineProps<Props>(), {
  moduleName: "",
  marginRight: 10,
  marginLeft: 0,
  linkNum: "",
});

const showLog = ref(false);
const time = ref([]);
const searchParams: any = reactive({
  merchantId: "",
  startDate: computed(() => {
    return time.value[0] || "";
  }),
  endDate: computed(() => {
    return time.value[1] || "";
  }),
  eventName: null,
  title: null,
  operName: null,
  operatorType: "",
  page: 1,
  limit: 10,
});

const loginUserType = computed(() => {
  return app?.$app.loginUserType || 0;
});

onMounted(() => {
  searchParams.module_name = props.moduleName;
  searchParams.merchantId = app?.$app.merchantId || "";
  // if (loginUserType.value == 1) {
  //   searchParams.operatorType = "";
  // } else {
  //   searchParams.operatorType = 2;
  // }
});

const search = () => {
  table.value.search();
};

//重置
const reset = () => {
  searchParams.eventName = null;
  searchParams.title = null;
  searchParams.operName = null;
  searchParams.operatorType = null;
  time.value = [];
  searchParams.page = 1;
  searchParams.limit = 10;
  loginUserType.value === 0 && (searchParams.merchantId = "");
  time.value = [];
  table.value.reset();
};

// 选择时间
const handleDate = (date: any) => {
  searchParams.startDate = date[0];
  searchParams.endDate = date[1];
};

// watch(
//   () => searchParams.merchantId,
//   (newVal) => {
//     console.log(searchParams.merchantId);

//     if (newVal > 0) {
//       searchParams.operatorType = 2;
//     }
//     if (newVal === 0) {
//       searchParams.operatorType = 3;
//     }
//     if (newVal === "" || newVal === null) {
//       searchParams.operatorType = "";
//     }
//   },
//   { immediate: true }
// );
</script>

<style lang="scss" scoped>
.log-list {
  .log-btn {
    border: 1px solid #5893f5;
  }
  :deep(.list-main) {
    background-color: rgb(255, 255, 255);
    border-radius: 5px;
    margin-bottom: 8px;
    margin-top: 8px;
    padding: 1px 24px 15px;
  }

  :deep(.search-box) {
    margin: 14px 0 10px;
    overflow: hidden;
  }

  :deep(.el-input__inner) {
    height: 32px;
    line-height: 32px;
    font-size: 12px;
  }

  :deep(.el-col) {
    box-sizing: border-box;
    padding-left: 0 !important;
    padding-right: 10px !important;
  }

  :deep(.el-date-editor) {
    .el-range-separator {
      line-height: 24px;
    }

    .el-input__icon {
      line-height: 26px;
    }
  }

  :deep(.el-date-editor--datetime) {
    width: 175px;
    margin-right: 10px;
  }
  .el-button-minor {
    height: 32px;
  }
}

:deep(.slot-content) {
  background-color: #fff;
}
.extension-page {
  margin-left: 10px !important;
  height: auto !important;
}

:deep(.navigation) {
  width: auto;
}

.log-list-popup {
  :deep(.navigation) {
    width: calc(90vw - 20px) !important;
  }
}

.log-list-page {
  :deep(.navigation) {
    width: calc(100vw - 115px) !important;
  }
}
</style>
